export default () => ({
  authType: null,
  userPassword: null,
  remainingTime: 2 * 60 * 1000,
});
